import React from "react";
import RoleSelect from "./RoleSelect";
import type { Role } from "../models/auth";

export default function RoleFilter({
  value,
  onChange,
  className,
}: {
  value: Role | null;
  onChange: (r: Role | null) => void;
  className?: string;
}): React.ReactElement {
  return (
    <div className={className}>
      <label className="mr-2 text-sm text-on-surface/70">Rol:</label>
      <RoleSelect value={value} onChange={onChange} />
    </div>
  );
}
